webpackJsonp([15],{

/***/ 63:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(3), __webpack_require__(11)], __WEBPACK_AMD_DEFINE_RESULT__ = function (utils, cookie) {
		'use strict';
	
		/**
		 * Steppable table
		 * A plugin that adds a pager feature to a table.
		 * @version 1.0.0
		 * @exports steppableTable
		 */
		var steppableTable = {
	
			/** Placeholder for base DOM element. */
			el: null,
	
			/** Placeholder for next-button DOM element. */
			nextBtn: null,
	
			/** Placeholder for previous-button DOM element. */
			prevBtn: null,
	
			/** Placeholder for the share-button DOM element. */
			shareBtn: null,
	
			/** Number that will refer to number of columns. */
			numCols: 0,
	
			/** Array that will contain the visible columns. */
			visibleCols: [],
	
			/** Array that will contain the hidden columns. */
			hiddenCols: [],
	
			/** Will contain the name of the cookie for this comparison list. */
			cookieName: null,
	
			/** Lifetime of the cookie in days. */
			cookieLifeLength: 365,
	
	
			/**
			 * The initialization function for this module.
			 * @param {Object} el - A DOM node.
			 * @public
			 */
			init: function (el) {
				this.el = el;
				this.nextBtn = document.querySelector('[data-type="steppableTable-next"]');
				this.prevBtn = document.querySelector('[data-type="steppableTable-prev"]');
				this.shareBtn = document.querySelector('[data-type="compare-share-btn"]');
				this.cookieName = this.el.getAttribute('data-cookiename');
				this._initDefaults();
				this._initRemoveButtons();
	
				if (this.nextBtn !== null && this.prevBtn !== null && this.numCols > 3) {
					this._initEvents();
				}
			},
	
	
			/**
			 * Method that creates the visibility-arrays and sets the numCols-variable.
			 * @private
			 */
			_initDefaults: function () {
				var that = this,
					cols = this.el.querySelectorAll('thead th'),
					visibleCols = [],
					hiddenCols = [];
	
				// We skip the header col.
				for (var i = 1; i < cols.length; i++) {
					var el = cols[i];
	
					if (that._isVisible(el) === true) {
						visibleCols.push(i);
					} else {
						hiddenCols.push(i);
					}
				}
	
				this.visibleCols = visibleCols;
				this.hiddenCols = hiddenCols;
				this.numCols = this.visibleCols.length + this.hiddenCols.length;
			},
	
	
			/**
			 * Method that steps one column forward.
			 * @private
			 */
			_gotoNext: function () {
				var colToHide = this.visibleCols[0],
					colToShow = this.hiddenCols[0],
					lastCol = true;
	
				utils.forEachElement('.col-' + colToHide, function (el) {
					utils.removeClass(el, 'visible-col');
					utils.addClass(el, 'hidden-col');
				});
				utils.forEachElement('.col-' + colToShow, function (el) {
					utils.removeClass(el, 'hidden-col');
					utils.addClass(el, 'visible-col');
				});
	
				this.visibleCols.splice(this.visibleCols.indexOf(colToHide), 1);
				this.visibleCols.push(colToShow);
				this.hiddenCols.splice(this.hiddenCols.indexOf(colToShow), 1);
				this.hiddenCols.push(colToHide);
	
				for (var i = 0; i < this.hiddenCols.length; i++) {
					if (this.hiddenCols[i] > colToShow) {
						lastCol = false;
						break;
					}
				}
	
				if (lastCol === true) {
					utils.addClass(this.nextBtn, 'is-inactive');
				}
				utils.removeClass(this.prevBtn, 'is-inactive');
			},
	
	
			/**
			 * Method that steps one column backward.
			 * @private
			 */
			_gotoPrev: function () {
				var colToHide = this.visibleCols[this.visibleCols.length - 1],
					colToShow = this.hiddenCols[this.hiddenCols.length - 1];
	
				utils.forEachElement('.col-' + colToHide, function (el) {
					utils.removeClass(el, 'visible-col');
					utils.addClass(el, 'hidden-col');
				});
				utils.forEachElement('.col-' + colToShow, function (el) {
					utils.removeClass(el, 'hidden-col');
					utils.addClass(el, 'visible-col');
				});
	
				this.visibleCols.splice(this.visibleCols.indexOf(colToHide), 1);
				this.visibleCols.unshift(colToShow);
				this.hiddenCols.splice(this.hiddenCols.indexOf(colToShow), 1);
				this.hiddenCols.unshift(colToHide);
	
				if (colToShow === 1) {
					utils.addClass(this.prevBtn, 'is-inactive');
				}
				utils.removeClass(this.nextBtn, 'is-inactive');
			},
	
	
			/**
			 * Method that removes a column.
			 * It also updates the cookie.
			 * @param {Number} id - The id of the item being removed.
			 * @param {Number} index - The index of the item being removed.
			 * @private
			 */
			_removeColumn: function (id, index) {
				var newCookie = [],
					cookieItems = null,
					arrayMethod = 'push',
					newVisibleCol;
	
				// Update cookie
				if (this.cookieName !== null) {
					try {
						cookieItems = JSON.parse(cookie.getCookie(this.cookieName));
					} catch (e) {}
	
					if (cookieItems !== null && cookieItems !== '') {
						for (var i = 0; i < cookieItems.length; i++) {
							if (cookieItems[i].id !== undefined && cookieItems[i].name !== undefined && cookieItems[i].url !== undefined && cookieItems[i].id !== id) {
								newCookie.push({ id: cookieItems[i].id, name: cookieItems[i].name, url: cookieItems[i].url });
							}
						}
						cookie.setCookie(this.cookieName, JSON.stringify(this.list), this.cookieLifeLength);
					}
				}
	
				// Get the new visible col
				if (utils.hasClass(this.nextBtn, 'is-inactive')) {
					newVisibleCol = this.hiddenCols[this.hiddenCols.length - 1];
					arrayMethod = 'unshift';
				} else {
					newVisibleCol = this.hiddenCols[0];
				}
	
				// Remove DOM nodes
				utils.forEachElement('.col-' + index, function (el) {
					if (el.remove) {
						el.remove();
					} else {
						el.parentNode.removeChild(el);
					}
				});
	
				// Update counter
				this.numCols -= 1;
	
				// Display new column
				utils.forEachElement('.col-' + newVisibleCol, function (el) {
					utils.removeClass(el, 'hidden-col');
					utils.addClass(el, 'visible-col');
				});
	
				// Update visibility arrays
				this.visibleCols.splice(this.visibleCols.indexOf(index), 1);
				if (arrayMethod === 'push') {
					this.visibleCols.push(newVisibleCol);
				} else {
					this.visibleCols.unshift(newVisibleCol);
				}
				this.hiddenCols.splice(this.hiddenCols.indexOf(newVisibleCol), 1);
	
				// Update next/prev-button state
				if (this.hiddenCols.length === 0) {
					utils.addClass(this.nextBtn, 'is-inactive');
					utils.addClass(this.prevBtn, 'is-inactive');
				}
	
				// Update the tables count-class
				if (this.numCols < 3) {
					utils.removeClass(this.el, 'compare-count-' + this.el.getAttribute('data-count'));
					utils.addClass(this.el, 'compare-count-' + this.numCols);
					this.el.setAttribute('data-count', this.numCols);
				}
			},
	
	
			/**
			 * Init click events.
			 * @private
			 */
			_initEvents: function () {
				var that = this;
	
				utils.addEventListener(this.nextBtn, 'click', function (event) {
					if (event.preventDefault) { event.preventDefault(); } else { event.returnValue = false; }
	
					if (utils.hasClass(that.nextBtn, 'is-inactive') === false) {
						that._gotoNext();
					}
				});
	
				utils.addEventListener(this.prevBtn, 'click', function (event) {
					if (event.preventDefault) { event.preventDefault(); } else { event.returnValue = false; }
	
					if (utils.hasClass(that.prevBtn, 'is-inactive') === false) {
						that._gotoPrev();
					}
				});
	
				utils.addClass(this.nextBtn, 'is-initialized');
				utils.addClass(this.prevBtn, 'is-initialized');
				utils.addClass(this.prevBtn, 'is-inactive');
			},
	
	
			/**
			 * Sets up clickevents for the remove-item buttons.
			 * @private
			 */
			_initRemoveButtons: function () {
				var that = this;
	
				utils.forEachElement('[data-type="compareRemoveBtn"]', function (el) {
					utils.addEventListener(el, 'click', function (event) {
						if (event.preventDefault) { event.preventDefault(); } else { event.returnValue = false; }
	
						var id = el.getAttribute('data-id'),
							index = parseInt(el.getAttribute('data-index'), 10),
							propName = el.getAttribute('data-propertyname'),
							newUrl = that._getNewUrl(propName, id);
	
						that._removeColumn(id, index);
						that._pathchange(newUrl);
						that._updateShareBtn(newUrl);
					});
				});
			},
	
	
			/**
			 * Detects if a DOM node (a column cell) is visible by testing the css position-attribute.
			 * If it's position is 'relative' it is visible, if it's absolut it's hidden.
			 * @param {Object} el - A DOM node.
			 * @public
			 */
			_isVisible: function (el) {
				var defaultView = (el.ownerDocument || document).defaultView,
					value;
	
				if (defaultView && defaultView.getComputedStyle) {
					value = defaultView.getComputedStyle(el, null).getPropertyValue('position');
				} else if (el.currentStyle) { // IE
					value = el.currentStyle.position;
				}
	
				return value === 'relative';
			},
	
	
			/**
			 * Function that updates the share-buttons url.
			 * @param {String} url - The new url.
			 * @private
			 */
			_updateShareBtn: function (url) {
				var hrefTpl = this.shareBtn.getAttribute('data-href-template'),
					newHref = hrefTpl.replace(/\[url\]/g, encodeURIComponent(url));
	
				this.shareBtn.setAttribute('href', newHref);
			},
	
	
			/**
			 * Function that updates the url.
			 * @param {String} url - The new url.
			 * @private
			 */
			_pathchange: function (url) {
				if (utils.hasHistorySupport()) {
					if (this.supportBackButton === 1) {
						window.history.pushState(null, null, url);
					} else {
						window.history.replaceState(null, null, url);
					}
				}
			},
	
	
			/**
			 * Function that returns the new url when a remove button has been pressed.
			 * @param {String} propName - The property name that should be removed from url.
			 * @param {Integer} id - The id that should be removed from url.
			 * @private
			 */
			_getNewUrl: function (propName, id) {
				var url = window.location.href;
	
				if (url.indexOf('?' + propName + '=' + id + '&') !== -1) {
					return url.replace(propName + '=' + id + '&', '');
				}
				else if (url.indexOf('?' + propName + '=' + id) !== -1) {
					return url.replace('?' + propName + '=' + id, '');
				} else {
					return url.replace('&' + propName + '=' + id, '');
				}
			}
		};
	
	
		return steppableTable;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ })

});


// WEBPACK FOOTER //
// partial.15.js